<template>
  <div>
    <ClientSearchList
      @init="handleClient_init"
      @submit="handleClient_submit"
    />

    <div class="columns my-0 is-multiline">
      <div class="column is-4">
        <kst-input floating-label load-on-focus
          field="Search" :data="searchData" :catalog="InvSearchCatalog"
          @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-output addons floating-label 
          field="ClientID" :data="searchData" :catalog="InvSearchCatalog"
        >
          <template #default>
            <kst-input floating-label
              field="Client" :data="searchData" :catalog="InvSearchCatalog"
              :disabled="clientDisabled" @input="handleInput"
            />
          </template>
          <template #right>
            <div class="control">
              <template v-if="searchData.ClientID === null">
                <kst-tooltip search-mode hover-only :content="InvSearchCatalog.ClientID.Label">
                  <kst-button search-mode @click="handleSearch_client"/>
                </kst-tooltip>
              </template>
              <template v-else>
                <kst-tooltip clear-mode hover-only :content="InvSearchCatalog.ClientID.Label">
                  <kst-button clear-mode @click="handleClear_client"/>
                </kst-tooltip>
              </template>
            </div>
          </template>
        </kst-output>
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="WarehouseID" :data="searchData" :catalog="InvSearchCatalog"
          :options="warehouseOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="Status" :data="searchData" :catalog="InvSearchCatalog"
          :options="statusOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="RecordTypeID" :data="searchData" :catalog="InvSearchCatalog"
          :options="recordTypeOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="InvoiceDate" :data="searchData" :catalog="InvSearchCatalog"
          @input="handleInput"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InvSearchCatalog from "../InvSearchCatalog.js";
import Model from "../InvModel.js";
import Services from "../../../services/Api/InvoiceServices.js";

import ClientSearchList from "../../Client/SearchList/CliScL.vue";

export default {
  components:{
    ClientSearchList
  },
  props: {
    searchData: Object,
    warehouseOptions: Object
  },
  data: () => ({
    InvSearchCatalog: InvSearchCatalog,
    // func
    showClientFunc: null
  }),
  computed: {
    clientDisabled() {
      return this.searchData.ClientID !== null;
    },
    recordTypeOptions() {
      return Model.createRecordTypeOptions(InvSearchCatalog.RecordTypeID.Label);
    },
    statusOptions() {
     return Model.createStatusOptions(InvSearchCatalog.Status.Label);
    }
  },
  methods: {
    /*** by Client modal ***/

    handleClient_init(show) {
      this.showClientFunc = show;
    },
    handleClient_submit(data) {
      this.searchData.ClientID = data.ID;
      this.searchData.Client = data.Name;
      this.handleInput();
    },

    /*** custom ***/

    handleInput() {
      this.$emit(this.$kst.Enum.Event.Input);
    },

    handleSearch_client() {
      this.showClientFunc(Services.getRelatedClientList);
    },
    handleClear_client() {
      this.searchData.ClientID = null;
      this.searchData.Client = "";

      this.handleInput();
    }
  }
}
</script>